const ENDPOINTS = {
  LOGIN: "/oauth/login",
  GROUPS: "/oauth/groups",
  USERS: "/oauth/user",
  ORDER_BY_FILTER: "/orders",
  ORDER_CANCEL: "/order/cancel",
  ORDER_FORCED_REVERSAL: "/order/forced-reversal",
  ORDER_REVERSAL: "/order/reversal",
  ORDER: "/order",
  ORDERS: "/orders",
  ORDER_RECEIPT: "/order-receipt",
  RECEIVABLE: "/receivable",
  RECEIVABLE_INSTALLMENTS_DOWNLOAD:
    "/receivable/installments/schedule/download",
  SUBSCRIPTION: "/subscription",
  SUBSCRIPTIONS: "/subscriptions",
  TRANSACTION: "/transaction",
  TRANSACTION_DOWNLOAD: "/transaction/csvFile/download",
  DASHBOARD: "/dashboard",
  DASHBOARD_PAYMENT: "/dashboard/payment",
  DASHBOARD_SMAUG: "/dashboard/smaug",
  DEFAULTER_ORDER: "/defaulter/order",
  DEFAULTER_ORDER_DOWNLOAD: "/defaulter/order/download",
  DEFAULTER_SUBSCRIPTION: "/defaulter/subscription",
  DEFAULTER_SUBSCRIPTION_DOWNLOAD:
    "/defaulter/subscription/download",
  RECEIVABLE_INSTALLMENTS: "/receivable/installments",
  LOGIN_WITH_PROVIDER: "/sso/{{email}}/authorization",
  PERMISSIONS: "/users/permissions",
  FORGOT_PASSWORD: "/oauth/forgot_password",
  FORGOT_PASSWORD_CONFIRM: "/oauth/forgot_password/confirm",
  FIRST_LOGIN: "/oauth/first_login",
  WHITE_LABELS: "/store/whitelabels",
  // Configurações de pagamento (portal-api-gateway → core). Imutáveis: não
  // há PUT/PATCH — mudar a regra é criar outra.
  PAYMENT_CONFIGURATIONS: "/payment-configurations",
  PAYMENT_CONFIGURATION: "/payment-configurations/{{id}}",
  PAYMENT_CONFIGURATION_ACTIVATE:
    "/payment-configurations/{{id}}/activate",
  PAYMENT_CONFIGURATION_DEACTIVATE:
    "/payment-configurations/{{id}}/deactivate",
  CANCEL: "/cancel",
  NOTIFICATION_CENTER_DASHBOARD_OVERVIEW:
    "/notification-center/dashboards/overview",
  NOTIFICATION_CENTER_NOTIFICATIONS:
    "/notification-center/notifications",
  NOTIFICATION_CENTER_NOTIFICATION_DETAIL:
    "/notification-center/notifications/{{uuid}}",
  NOTIFICATION_CENTER_NOTIFICATION_RESEND:
    "/notification-center/notifications/{{uuid}}/resend",
  NOTIFICATION_CENTER_WHITE_LABELS:
    "/notification-center/white-labels",
  NOTIFICATION_CENTER_WHITE_LABELS_CONFIGURATIONS:
    "/notification-center/white-labels/{{whiteLabelId}}/configurations",
  NOTIFICATION_CENTER_WHITE_LABELS_CONFIGURATIONS_DEFAULT:
    "/notification-center/white-labels/{{whiteLabelId}}/configurations/default",
  NOTIFICATION_CENTER_WHITE_LABELS_CONFIGURATION:
    "/notification-center/white-labels/{{whiteLabelId}}/configuration",
  NOTIFICATION_CENTER_WHITE_LABELS_TEMPLATES:
    "/notification-center/white-labels/{{whiteLabelId}}/templates",
  NOTIFICATION_CENTER_WHITE_LABELS_EVENTS:
    "/notification-center/white-labels/{{whiteLabelId}}/events",
  NOTIFICATION_CENTER_WHITE_LABELS_EVENT:
    "/notification-center/white-labels/{{whiteLabelId}}/events/{{eventName}}",
  NOTIFICATION_CENTER_WHITE_LABELS_EVENT_SCHEDULERS:
    "/notification-center/white-labels/{{whiteLabelId}}/events/{{eventName}}/schedulers",
  NOTIFICATION_CENTER_WHITE_LABELS_EVENT_SCHEDULER:
    "/notification-center/white-labels/{{whiteLabelId}}/events/{{eventName}}/schedulers/{{schedulerUuid}}",
  NOTIFICATION_CENTER_WHITE_LABELS_EVENT_TEMPLATES:
    "/notification-center/white-labels/{{whiteLabelId}}/events/{{eventName}}/templates",
  NOTIFICATION_CENTER_TEMPLATES:
    "/notification-center/templates",
  NOTIFICATION_CENTER_TEMPLATE_VERSIONS:
    "/notification-center/templates/{{templateUuid}}/versions",
  NOTIFICATION_CENTER_TEMPLATE_EVENTS:
    "/notification-center/templates/{{templateUuid}}/events",
  NOTIFICATION_CENTER_TEMPLATE_VERSION_ACTIVATE:
    "/notification-center/templates/{{templateUuid}}/versions/{{version}}/activate",
  NOTIFICATION_CENTER_TEMPLATE_TEST_SEND:
    "/notification-center/templates/{{templateUuid}}/test-send",
  NOTIFICATION_CENTER_TEMPLATE_AI_IMPROVE:
    "/notification-center/templates/{{templateUuid}}/ai-improve",
  TEMPLATES_CONFIGURATION:
    "/notification-center/templates-configuration/",
  NOTIFICATION_CENTER_WHITE_LABELS_ID_PROVIDER:
    "/notification-center/white-labels/{{whiteLabelId}}/providers",
  NOTIFICATION_CENTER_WHITE_LABELS_PROVIDER_CHANNEL:
    "/notification-center/white-labels/{{whiteLabelId}}/providers/{{channel}}",
  NOTIFICATION_CENTER_WHITE_LABELS_PROVIDERS_ZENVIA_CREDENTIALS:
    "/notification-center/white-labels/{{whiteLabelId}}/providers/zenvia/credentials",
  NOTIFICATION_CENTER_WHITE_LABELS_PROVIDERS_ZENVIA_JOURNEYS:
    "/notification-center/white-labels/{{whiteLabelId}}/providers/zenvia/journeys",
  NOTIFICATION_CENTER_WHITE_LABELS_PROVIDERS_ZENVIA_JOURNEY:
    "/notification-center/white-labels/{{whiteLabelId}}/providers/zenvia/journeys/{{journeyId}}",
  NOTIFICATION_CENTER_WHITE_LABELS_PROVIDERS_ZENVIA_TEST:
    "/notification-center/white-labels/{{whiteLabelId}}/providers/zenvia/test",
  WEBHOOKS: "/webhooks",
  CUSTOMERS: "/customers",
  CUSTOMER_BY_ID: "/customers/{{customerId}}",
  CUSTOMER_CARDS: "/customers/{{customerId}}/cards",
  CUSTOMER_CARD_BY_ID:
    "/customers/{{customerId}}/cards/{{cardId}}",
  CHECKOUT_SUBSCRIPTION:
    "/checkout/subscription/{{subscriptionId}}/url?sendNotification=true",
  WHITELABEL_CONFIGURATION:
    "/domains/{{domain}}/configurations",
  WHITELABEL_CONFIGURATION_BY_MERCHANT:
    "/merchant/{{merchantId}}/configurations",
  REPIC_CONFIGURATION: "/repic/configuration",
  SMART_ROUTING_CONFIGURATIONS:
    "/smart-routing/configurations",
  SMART_ROUTING_METRICS: "/smart-routing/metrics",
  SMART_ROUTING_PERIODS: "/smart-routing/periods",
  SMART_ROUTING_PROCESSORS: "/smart-routing/processors",
  SMART_ROUTING_PAYMENT_METHODS:
    "/smart-routing/payment-methods",
  ADMIN_REPROCESS_WAITING_WITH_PAID_TRANSACTION:
    "/admin/reprocess/waiting-with-paid-transaction",
  ADMIN_REPROCESS_PRE_AUTHORIZED:
    "/admin/reprocess/pre-authorized",
  ADMIN_REPROCESS_ALL: "/admin/reprocess/all",
  // Webhooks recebidos dos processadores (payment). O detalhe é
  // `${WEBHOOK_INBOX}/{id}` e o reprocesso `${WEBHOOK_INBOX}/{id}/reprocess`.
  WEBHOOK_INBOX: "/webhook-inbox",
  WEBHOOK_INBOX_SUMMARY: "/webhook-inbox/summary",
  // Credenciais de integração do white label. Detalhe: `${APP_CREDENTIALS}/{uuid}`;
  // segredo: `${APP_CREDENTIALS}/{uuid}/secret` (auditado no gateway).
  APP_CREDENTIALS: "/app-credentials",
  // Base da consulta de dados do boleto direto no banco (Super Admin).
  // URL final: `${ADMIN_BOLETO}/${paymentTransactionId}/bank-data`.
  ADMIN_BOLETO: "/admin/boleto",
  ADMIN_PROCESSOR_CONFIG: "/admin/processor-config",
  ADMIN_PROCESSOR_CONFIG_METADATA:
    "/admin/processor-config/metadata",
  ADMIN_PROCESSOR_CONFIG_ACTIVATE:
    "/admin/processor-config/{{uuid}}/activate",
  ADMIN_PROCESSOR_CONFIG_DEACTIVATE:
    "/admin/processor-config/{{uuid}}/deactivate",
  // Elege a configuração como PADRÃO do par WL+método (V176) — o backend
  // desliga o padrão anterior atomicamente antes de marcar o novo.
  ADMIN_PROCESSOR_CONFIG_SET_DEFAULT:
    "/admin/processor-config/{{uuid}}/set-default",
  ADMIN_PROCESSOR_CONFIG_DETAIL:
    "/admin/processor-config/{{uuid}}",
  ADMIN_PROCESSOR_CONFIG_TEST_CONNECTION:
    "/admin/processor-config/{{uuid}}/test-connection",
  ADMIN_PROCESSOR_CONFIG_ALLOWED_METHODS:
    "/admin/processor-config/white-labels/{{uuid}}/allowed-methods",
  // Cofre do merchant DO WHITE LABEL — não o do usuário logado
  // (ADMIN_MERCHANT_MTLS_CERTIFICATES). O vínculo é validado contra o
  // merchant da configuração; oferecer outro cofre resulta em 404 ao salvar.
  ADMIN_PROCESSOR_CONFIG_VAULT_CERTIFICATES:
    "/admin/processor-config/white-labels/{{uuid}}/mtls-certificates",
  // Processadores que as configuracoes deste white label podem apontar — os do
  // MERCHANT do white label, nao os do usuario logado.
  // Aponta a configuracao para outro processador do mesmo merchant — e' o que
  // consolida credenciais duplicadas.
  ADMIN_PROCESSOR_CONFIG_CHANGE_PROCESSOR:
    "/admin/processor-config/{{uuid}}/processor",
  // Escolhe a credencial de CONTINGENCIA da configuracao. Corpo obrigatorio;
  // `processorId: null` espelha o principal (a coluna e' NOT NULL, entao "sem
  // contingencia" nao existe).
  ADMIN_PROCESSOR_CONFIG_CHANGE_FALLBACK:
    "/admin/processor-config/{{uuid}}/fallback",
  ADMIN_PROCESSOR_CONFIG_ELIGIBLE_PROCESSORS:
    "/admin/processor-config/white-labels/{{whiteLabelId}}/processors",
  ADMIN_PROCESSOR_CONFIG_CERTIFICATE:
    "/admin/processor-config/{{uuid}}/certificate",
  ADMIN_PROCESSOR_CONFIG_CERTIFICATE_RENEW:
    "/admin/processor-config/{{uuid}}/certificate/renew",
  // Trilha das mudancas de roteamento: quem ligou, desligou, moveu ou apagou.
  ADMIN_PROCESSOR_CONFIG_EVENTS:
    "/admin/processor-config/{{uuid}}/events",
  ADMIN_PROCESSOR_CONFIG_CERTIFICATE_HISTORY:
    "/admin/processor-config/{{uuid}}/certificate/history",
  ADMIN_WHITE_LABELS: "/white-labels",
  ADMIN_WHITE_LABEL: "/white-labels/{{uuid}}",
  ADMIN_WHITE_LABEL_CONFIGURATIONS:
    "/white-labels/{{uuid}}/configurations",
  ADMIN_WHITE_LABEL_PAYMENT_METHODS:
    "/white-labels/{{uuid}}/payment-methods",
  ADMIN_WHITE_LABEL_PAYMENT_METHOD:
    "/white-labels/{{uuid}}/payment-methods/{{method}}",
  ADMIN_WHITE_LABEL_REPORT_CONFIGURATION:
    "/white-labels/{{uuid}}/report-configuration",
  ADMIN_WHITE_LABEL_INSURANCE_TYPES:
    "/white-labels/{{uuid}}/insurance-types",
  ADMIN_WHITE_LABEL_INSURANCE_TYPE:
    "/white-labels/{{uuid}}/insurance-types/{{code}}",
  // Cofre de certificados mTLS do merchant (BFF /admin/merchant-mtls-certificates).
  // Sem storeUuid: o merchant sai do token no gateway — o front não escolhe de
  // qual loja é o cofre.
  ADMIN_MERCHANT_MTLS_CERTIFICATES:
    "/admin/merchant-mtls-certificates",
  ADMIN_MERCHANT_MTLS_CERTIFICATE:
    "/admin/merchant-mtls-certificates/{{certificateId}}",
  ADMIN_MERCHANT_MTLS_CERTIFICATE_HISTORY:
    "/admin/merchant-mtls-certificates/{{certificateId}}/history",
  ADMIN_MERCHANT_MTLS_CERTIFICATE_RENEW:
    "/admin/merchant-mtls-certificates/{{certificateId}}/renew",
  // Processadores do merchant (BFF /admin/merchant-processors). Sem storeUuid
  // pelo mesmo motivo do cofre: o merchant sai do token no gateway.
  ADMIN_MERCHANT_PROCESSORS: "/admin/merchant-processors",
  ADMIN_MERCHANT_PROCESSOR:
    "/admin/merchant-processors/{{processorId}}",
  ADMIN_MERCHANT_PROCESSOR_TEST_CONNECTION:
    "/admin/merchant-processors/{{processorId}}/test-connection",
  ADMIN_MERCHANTS: "/merchants",
  ADMIN_MERCHANT: "/merchants/{{uuid}}",
  ADMIN_MERCHANT_PAYMENT_METHODS:
    "/merchants/{{uuid}}/payment-methods",
  ADMIN_MERCHANT_PAYMENT_METHOD:
    "/merchants/{{uuid}}/payment-methods/{{method}}",
  // Catálogo do que dá para habilitar (linhas ativas de payment_method no
  // backoffice). Compartilhado por merchant e white label.
  PAYMENT_METHOD_CATALOG: "/payment-methods",
} as const
export default ENDPOINTS
